import * as library from './exports.js'
import PACKAGE_JSON from '../package.json' with { type : 'json' }

const VERSION = PACKAGE_JSON.version

let GLOBAL = { }
if ( typeof window === 'object' ) {
  GLOBAL = window
} else if ( typeof global === 'object' ) {
  GLOBAL = global
}

if ( GLOBAL.leveregePlugin ) {
  const version = GLOBAL.leveregePlugin.version
  // eslint-disable-next-line no-console
  console.log( `Version ${VERSION} of @leverege/plugins library found another installed verison: ${version}` )
} else {
  GLOBAL.leveregePlugin = {
    version : VERSION,
    library
  }
}

const { Plugins, Isa, Factory, Context, PluginCreator, Match, Layout, View, Config, Util, resolve } = GLOBAL.leveregePlugin.library

export {
  Plugins,
  Isa,
  Factory,
  Context,
  PluginCreator,
  Match,
  Layout,
  View,
  Config,
  Util,
  resolve
}
